import { render, staticRenderFns } from "./InformationAboutHeath.vue?vue&type=template&id=53de2486&"
import script from "./InformationAboutHeath.vue?vue&type=script&lang=js&"
export * from "./InformationAboutHeath.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports